import { CustomerPositions } from '@src/containers/Dealer/CustomerPositions';
import type { CustomerPositionsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerPositionsPanel({ api, params }: LayoutPanelProps<CustomerPositionsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-positions-panel"
    >
      <CustomerPositions />
    </EntityAdminPanelShell>
  );
}
